import { useEffect, useState } from 'react';
import { getInstanceUid } from '../utils/params';

/**
 * Hook to safely retrieve the instance UID from the DOM context
 * This hook is designed to work with multiple DRE 2.0 instances
 * Uses the centralized getInstanceUid function from params.js
 * @returns {string} The UID for the current instance
 */
export default function useUid() {
  const [uid, setUid] = useState('dre20params');

  useEffect(() => {
    // Use the centralized UID resolver from params.js
    const foundUid = getInstanceUid(document);

    // Update state if we found a different UID
    if (foundUid && foundUid !== uid) {
      setUid(foundUid);
    }
  }, []); // Empty dependency array - only run once on mount

  return uid;
}
